import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

const SHOW_AFTER_PX = 400;

/**
 * Floating "back to top" button — appears bottom-right after the user
 * scrolls past 400px, fades smoothly, and respects the cookie banner /
 * footer area through bottom positioning. Hidden inside the admin app
 * to stay out of the way of operator workflows.
 */
export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > SHOW_AFTER_PX);
    onScroll(); // initialise (e.g. when user lands deep-linked to an anchor)
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Suppress on admin routes — they have their own dense headers.
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
    return null;
  }

  return (
    <button
      type="button"
      data-testid="back-to-top"
      aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={[
        "fixed bottom-6 right-6 z-40",
        "h-11 w-11 rounded-full",
        "bg-zinc-950 text-white shadow-lg shadow-zinc-900/20",
        "flex items-center justify-center",
        "transition-all duration-300 ease-out",
        "hover:bg-zinc-800 hover:-translate-y-0.5",
        show ? "opacity-100 pointer-events-auto translate-y-0" : "opacity-0 pointer-events-none translate-y-2",
      ].join(" ")}
    >
      <ArrowUp size={18} />
    </button>
  );
}
